import React from "react";
import { useLocation } from "react-router-dom";
import { useCart } from "@ecommerce/store";
import { useCategories } from "./hooks/useCategories";
import { useCategoriesNavigation } from "./hooks/useNavigation";
import { useNavbarCategoriesDrawer } from "./hooks/useNavbarCategoriesDrawer";
import ShoppingCartDrawer from "../ShoppingCart/ShoppingCartDrawer";
import { CategoriesDrawer } from "./Navbar/CategoriesMenu/CategoriesDrawer";
import { GlassNav, PromoStrip } from "../liquid/LiquidPrimitives";

const getActiveNavKey = (pathname: string) => {
    if (pathname === "/") return "home";
    if (pathname === "/faqs") return "faqs";
    const match = pathname.match(/\/categoria\/([^/]+)/);
    if (match) return match[1];
    return "";
};

const Header: React.FC = () => {
    const location = useLocation();
    const { cartBadgeCount, cartItems, isCartOpen, toggleCart, closeCart } = useCart();
    const { rootCategories, loading, error, getSubcategories } = useCategories();

    const {
        drawerOpen,
        productosOpen,
        expandedCategories,
        toggleDrawer,
        toggleProductos,
        toggleCategory,
        closeDrawer,
    } = useNavbarCategoriesDrawer();

    const { handleNavigation, handleCategoryClick, handleViewAllInCategory } =
        useCategoriesNavigation(closeDrawer);

    return (
        <>
            <PromoStrip />
            <GlassNav
                active={getActiveNavKey(location.pathname)}
                cartCount={cartBadgeCount}
                onMenuClick={toggleDrawer}
                onCartClick={toggleCart}
                categories={[...rootCategories]
                    .sort((a, b) => (a.orden ?? 999999) - (b.orden ?? 999999))
                    .slice(0, 4)}
            />

            <CategoriesDrawer
                isOpen={drawerOpen}
                loading={loading}
                error={error}
                rootCategories={rootCategories}
                productosOpen={productosOpen}
                expandedCategories={expandedCategories}
                onClose={closeDrawer}
                onNavigate={handleNavigation}
                onToggleProductos={toggleProductos}
                onToggleCategory={toggleCategory}
                onCategoryClick={handleCategoryClick}
                onViewAllClick={handleViewAllInCategory}
                getSubcategories={getSubcategories}
            />

            <ShoppingCartDrawer cartItems={cartItems} isOpen={isCartOpen} onClose={closeCart} />
        </>
    );
};

export default Header;
